
      import { gameCatalog } from "./multiplayer/shared/gameCatalog.ts";

      var leaderboardGames = gameCatalog().filter(function (game) {
        return game.leaderboards.length > 0;
      });
      var gameBoards = leaderboardGames
        .filter(function (game) {
          return game.id !== "tanks";
        })
        .flatMap(function (game) {
          return game.leaderboards.map(function (board) {
            return {
              key: game.id + ":" + board.boardId,
              gameId: game.id,
              boardId: board.boardId,
              label: game.leaderboards.length === 1 ? game.title : game.title + " · " + board.title,
            };
          });
        });
      var modes = ["multiplayer_survival", "multiplayer_campaign", "singleplayer"].concat(
        gameBoards.map(function (board) {
          return board.key;
        }),
      );
      var currentMode = "multiplayer_survival";
      var allScores = {
        multiplayer_survival: [],
        multiplayer_campaign: [],
        singleplayer: [],
      };
      gameBoards.forEach(function (board) {
        allScores[board.key] = [];
      });
      var searchTerm = "";

      function renderTabs() {
        var labels = ["Co-op Survival", "Co-op Campaign", "Solo Campaign"].concat(
          gameBoards.map(function (board) {
            return board.label;
          }),
        );
        document.getElementById("leaderboard-tabs").innerHTML = modes
          .map(function (mode, index) {
            return (
              '<button class="tab-btn' +
              (index === 0 ? " active" : "") +
              '" data-mode="' +
              mode +
              '">' +
              escapeHtml(labels[index]) +
              "</button>"
            );
          })
          .join("");
        document.querySelectorAll(".tab-btn").forEach(function (button) {
          button.addEventListener("click", function () {
            setMode(button.getAttribute("data-mode"));
          });
        });
      }

      function loadScores() {
        // 1. Load singleplayer scores from localStorage
        try {
          var localRaw = localStorage.getItem("3dtanks.scores.v2");
          if (localRaw) {
            var scores = JSON.parse(localRaw);
            allScores.singleplayer = scores
              .filter(function (s) {
                return s.mode === "campaign";
              })
              .map(function (s) {
                return {
                  name: "Local Commander",
                  score: s.score,
                  meta: s.levelReached ? "Cleared: " + s.levelReached.toUpperCase() : "In Progress",
                  date: s.date,
                };
              })
              .sort(function (a, b) {
                return b.score - a.score;
              });
          }
        } catch (e) {
          console.error(e);
        }

        // 2. Fetch server scores from HTTP server API. Each request is independent so
        // offline or local-only play still shows whatever scores are available.
        var apiHost =
          window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
            ? "http://" + window.location.hostname + ":8787"
            : ""; // relative path for production
        fetch(apiHost + "/leaderboards/tanks/best-runs")
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            var survival = [];
            var campaign = [];
            data.rows.forEach(function (s) {
              var entry = {
                name: s.name,
                score: s.score,
                meta: s.meta,
                date: s.date,
              };
              if (s.group === "survival") {
                survival.push(entry);
              } else {
                campaign.push(entry);
              }
            });
            allScores.multiplayer_survival = survival.sort(function (a, b) {
              return b.score - a.score;
            });
            allScores.multiplayer_campaign = campaign.sort(function (a, b) {
              return b.score - a.score;
            });
            render();
          })
          .catch(function (err) {
            console.error("Could not load multiplayer scores", err);
            render();
          });
        gameBoards.forEach(function (board) {
          loadGameLeaderboard(apiHost, board.gameId, board.boardId, board.key);
        });
        fetch(apiHost + "/single-player-high-scores")
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            allScores.singleplayer = data
              .map(function (s) {
                return {
                  name: s.playerName || "Solo Commander",
                  score: s.score,
                  meta:
                    s.mode === "survival"
                      ? "Wave " + (s.waveReached || "-")
                      : s.state === "victory"
                        ? "Campaign Victory"
                        : s.levelReached
                          ? "Cleared: " + s.levelReached.toUpperCase()
                          : "Campaign",
                  date: s.completedAt,
                };
              })
              .sort(function (a, b) {
                return b.score - a.score;
              });
            render();
          })
          .catch(function (err) {
            console.error("Could not load single-player scores", err);
            render();
          });
      }

      function loadGameLeaderboard(apiHost, gameId, boardId, key) {
        fetch(apiHost + "/leaderboards/" + gameId + "/" + boardId)
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            allScores[key] = (data.rows || []).map(function (row) {
              return { name: row.name, score: row.score, meta: row.meta, date: row.date };
            });
            render();
          })
          .catch(function () {
            allScores[key] = [];
            render();
          });
      }

      function setMode(mode) {
        currentMode = mode;
        document.querySelectorAll(".tab-btn").forEach(function (btn) {
          btn.classList.remove("active");
        });
        var btnIndex = modes.indexOf(mode);
        var activeButton = document.querySelectorAll(".tab-btn")[btnIndex];
        if (activeButton) activeButton.classList.add("active");
        render();
      }

      function handleSearch(val) {
        searchTerm = val.toLowerCase();
        render();
      }

      function render() {
        var list = allScores[currentMode] || [];
        if (searchTerm) {
          list = list.filter(function (item) {
            return item.name.toLowerCase().indexOf(searchTerm) !== -1;
          });
        }

        var podiumContainer = document.getElementById("podium-container");
        var ranksContainer = document.getElementById("ranks-container");

        if (list.length === 0) {
          podiumContainer.innerHTML = "";
          ranksContainer.innerHTML =
            '<div class="empty-state">No scores logged yet. Be the first to claim a rank!</div>';
          return;
        }

        // Render Podium (top 3)
        var podiumHtml = "";
        var podiumItems = list.slice(0, 3);

        var classes = ["first", "second", "third"];
        var badges = ["👑 #1", "🥈 #2", "🥉 #3"];

        // Loop through whatever is available up to top 3
        podiumItems.forEach(function (item, idx) {
          // Adjust index mappings if 1st, 2nd, 3rd exist
          var displayIdx = idx;
          podiumHtml +=
            '<div class="podium-card ' +
            classes[displayIdx] +
            '">' +
            '<div class="podium-badge">' +
            badges[displayIdx] +
            "</div>" +
            '<div class="podium-name">' +
            escapeHtml(item.name) +
            "</div>" +
            '<div class="podium-score">' +
            item.score.toLocaleString() +
            "</div>" +
            '<div class="podium-meta">' +
            escapeHtml(item.meta) +
            "</div>" +
            "</div>";
        });
        podiumContainer.innerHTML = podiumHtml;

        // Render remaining list (#4+)
        var ranksItems = list.slice(3);
        var tableHtml = "";

        if (ranksItems.length === 0) {
          ranksContainer.innerHTML = "";
          return;
        }

        ranksItems.forEach(function (item, idx) {
          var rankNum = idx + 4;
          tableHtml +=
            '<div class="rank-row">' +
            '<div class="col-rank">#' +
            rankNum +
            "</div>" +
            '<div class="col-name">' +
            escapeHtml(item.name) +
            "</div>" +
            '<div class="col-meta">' +
            escapeHtml(item.meta) +
            "</div>" +
            '<div class="col-score">' +
            item.score.toLocaleString() +
            "</div>" +
            "</div>";
        });
        ranksContainer.innerHTML = tableHtml;
      }

      function escapeHtml(str) {
        return str
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;");
      }

      // Initial load
      renderTabs();
      document.getElementById("search").addEventListener("input", function (event) {
        handleSearch(event.target.value);
      });
      loadScores();
    